export default __webpack_public_path__ + "static/media/shopeepayLogo.2d041928.svg";